"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IshtarMining = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var IshtarMining = (function (_super) {
    __extends(IshtarMining, _super);
    function IshtarMining() {
        return _super.call(this, {
            name: CardName_1.CardName.ISHTAR_MINING,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.VENUS],
            cost: 5,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.venus(8); }),
            metadata: {
                cardNumber: '233',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.production(function (pb) { return pb.titanium(1); }); }),
                description: 'Requires Venus 8%. Increase your titanium production 1 step.',
            },
        }) || this;
    }
    IshtarMining.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    };
    return IshtarMining;
}(Card_1.Card));
exports.IshtarMining = IshtarMining;
//# sourceMappingURL=IshtarMining.js.map